import StaticFixtureSpritesheet from "../sprite/StaticFixtureSpritesheet";
import FixtureDescription from "./FixtureDescription";
import StaticFixtureDescription from "./StaticFixureDescription";

export const FixtureDescriptions = {};


// // Iterate over the sprite name configs
// for (let typeName of Object.values(FixtureTypeNames)) {
//     for (let colorName of Object.values(FixtureSpriteColors)) {
//         const name = StaticFixtureSpritesheet.getSpriteName(typeName, colorName);
//         FixtureDescriptions[name] = new StaticFixtureDescription(typeName, colorName, true, false, false);
//     }
// }

/**
 * @param {string} typeName 
 * @param {string} colorName 
 * @returns {FixtureDescription}
 */
FixtureDescriptions.getDescription = (typeName, colorName) =>  {
    
    // If we add more fixture spritesheets (eg AnimatedFixtureSpritesheet), we may have to rethink how we do this stuff.
    
    const spriteName = StaticFixtureSpritesheet.getSpriteName(typeName, colorName);

    // Let's lazily create descriptions as needed.
    let desc = FixtureDescriptions[spriteName];
    if (!desc) {
        desc = new StaticFixtureDescription(typeName, colorName, spriteName, true, false, false);
        FixtureDescriptions[spriteName] = desc;
    }

    return desc;
};

